const features = [
  {
    icon: 'ri-coin-fill',
    gradient: 'from-amber-400 to-orange-500',
    title: '积分奖惩系统',
    desc: '自定义奖惩规则，好习惯得积分，坏习惯扣积分，持续犯错还可加倍扣分，机制灵活可配置。'
  },
  {
    icon: 'ri-team-fill',
    gradient: 'from-blue-500 to-indigo-600',
    title: '家庭成员管理',
    desc: '支持父母、祖父母等多成员关联，分管理权与操作权，爷爷奶奶也能参与孩子成长管理。'
  },
  {
    icon: 'ri-price-tag-3-fill',
    gradient: 'from-purple-500 to-pink-500',
    title: '智能习惯标签',
    desc: '六大习惯维度：时间管理、学习专注、生活自理、运动健康、责任担当、言行礼仪，全面评估成长。'
  },
  {
    icon: 'ri-store-3-fill',
    gradient: 'from-green-500 to-teal-500',
    title: '积分兑换商城',
    desc: '孩子可用积分换取陪伴时光、电影、美食、玩具，让积分真正具有价值，激发积极性。'
  },
  {
    icon: 'ri-bank-fill',
    gradient: 'from-cyan-500 to-blue-500',
    title: '家庭银行系统',
    desc: '管理孩子零花钱，支持存款、取款、积分兑换，设置利率像真实银行一样培养理财意识。'
  },
  {
    icon: 'ri-robot-2-fill',
    gradient: 'from-rose-500 to-orange-500',
    title: 'AI智能助手',
    desc: '直接说"小明完成了800米跑步"，AI自动识别并记录积分变动，支持语音和文字双模式。'
  },
  {
    icon: 'ri-bar-chart-2-fill',
    gradient: 'from-violet-500 to-purple-600',
    title: '数据分析看板',
    desc: '追踪孩子习惯养成进度，雷达图展示六维习惯评分，智能分析各机制对习惯的贡献率。'
  },
  {
    icon: 'ri-store-fill',
    gradient: 'from-emerald-500 to-green-600',
    title: '激励方案市场',
    desc: '将家庭奖惩机制分享至市场，借鉴其他家庭优秀经验，支持整套打包或单项购买。'
  },
  {
    icon: 'ri-smartphone-fill',
    gradient: 'from-sky-500 to-blue-600',
    title: '多端无缝同步',
    desc: '支持PC端、H5、微信小程序、公众号全平台，随时随地记录孩子每一个精彩瞬间。'
  }
];

export default function FeaturesSection() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div id="features" className="inline-flex items-center gap-2 bg-orange-50 text-orange-700 text-sm px-4 py-2 rounded-full mb-4 font-medium">
            <i className="ri-sparkling-2-fill"></i>
            <span>核心功能</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-[#0d2d6e] mb-4">一站式家庭习惯养成系统</h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">从记录到分析，从激励到成长，全方位守护孩子的习惯培养之旅</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feat, i) => (
            <div key={i} className="group bg-white border border-gray-100 rounded-2xl p-6 hover:-translate-y-1 transition-all duration-300 cursor-pointer hover:border-blue-100" style={{boxShadow:'0 2px 12px rgba(0,0,0,0.04)'}}>
              <div className={`w-12 h-12 flex items-center justify-center rounded-2xl bg-gradient-to-r ${feat.gradient} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feat.icon} text-white text-xl`}></i>
              </div>
              <h3 className="font-bold text-[#0d2d6e] text-base mb-2">{feat.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
